// eslint-disable-next-line import/extensions
import services from '../services/message.js'
import { message } from 'antd'

const {
  getMessageList,
  getUnreadCount,
  getMessageDetail,
  handleReceipt,
  getFeedbackData,
  addFeedback,
  getFeedbackOrgTree,
  getAllCount,
  getNotAckedCount,
} = services

const namespace = 'message'

export default {
  namespace,
  state: {
    allMessage: {
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      total: 0,
      list: [
        {
          messageTopic: '123',
          currentTime: '213',
        },
      ],
    },
    unreadMessage: {
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      total: 0,
      list: [],
    },
    receiptMessage: {
      pageNo: 1,
      pageSize: 10,
      pageTotal: 0,
      total: 0,
      list: [],
    },
    unreadCount: 0,
    allCount: 0,
    notAckedCount: 0,
    detailVisible: false,
    detailData: {},
    // 反馈列表
    feedbackData: {
      pageNo: 1,
      pageSize: 5,
      pageTotal: 0,
      total: 0,
      list: [],
    },
    feedbackOrgOptions: [],
    addFeedbackVisible: false,
  },

  reducers: {
    updateState(state, { payload }) {
      return {
        ...state,
        ...payload,
      }
    },
  },

  effects: {
    // 更新数据
    *update({ payload, callback }, { put }) {
      yield put({
        type: 'updateState',
        payload: { ...payload },
      })
    },

    // 全部消息列表
    *getAllMessage({ payload, callback }, { call, put }) {
      const res = yield call(getMessageList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            allMessage: res.data,
          },
        })
      }
    },

    // 未读消息列表
    *getUnreadMessage({ payload, callback }, { call, put }) {
      const res = yield call(getMessageList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            unreadMessage: res.data,
          },
        })
        callback && callback()
      }
    },

    // 已回执消息列表
    *getReceiptMessage({ payload, callback }, { call, put }) {
      const res = yield call(getMessageList, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            receiptMessage: res.data,
          },
        })
      }
    },

    // 未读数量
    // 加上了未反馈数量，total数量
    *getUnreadCount({ callback }, { call, put }) {
      const res1 = yield call(getUnreadCount, {})
      const res2 = yield call(getAllCount, {})
      const res3 = yield call(getNotAckedCount, {})
      const payload = {}
      if (res1.success) {
        payload.unreadCount = res1.data
      }
      if (res2.success) {
        payload.allCount = res2.data
      }
      if (res3.success) {
        payload.notAckedCount = res3.data
      }

      yield put({
        type: 'updateState',
        payload,
      })
    },

    // 消息详情
    *getMessageDetail({ payload, callback }, { call, put }) {
      const res = yield call(getMessageDetail, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            detailVisible: true,
            detailData: res.data,
          },
        })
        callback && callback()
      }
    },

    // 消息回执
    *handleReceipt({ payload, callback }, { call, put }) {
      const res = yield call(handleReceipt, { ...payload })
      if (res.success) {
        message.success('回执成功')
        callback && callback()
      }
    },

    // 反馈列表
    *getFeedbackData({ payload, callback }, { call, put }) {
      const res = yield call(getFeedbackData, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            feedbackData: res.data,
          },
        })
      }
    },

    // 新增反馈
    *addFeedback({ payload, callback }, { call, put }) {
      const res = yield call(addFeedback, { ...payload })
      if (res.success) {
        message.success('新增成功')
        yield put({
          type: 'updateState',
          payload: {
            addFeedbackVisible: false,
          },
        })
        callback && callback()
      }
    },

    *getFeedbackOrgOptions({ payload, callback }, { call, put }) {
      const res = yield call(getFeedbackOrgTree, { ...payload })
      if (res.success) {
        yield put({
          type: 'updateState',
          payload: {
            feedbackOrgOptions: res.data.map((d) => ({
              value: d.id,
              label: d.name,
            })),
          },
        })
        callback && callback()
      }
    },
  },
  // 订阅事件
  subscriptions: {},
}
